const user = {
  state: {
    isConnected: false,
    type: null,
    accessToken: null,
    refreshToken: null,
    hasPhoneNumber: null,
  },
  getters: {
    hasPhoneNumber: state => state.hasPhoneNumber,
    isConnected: state => state.isConnected,
    getType: state => state.type,
    getAccessToken: state => state.accessToken,
    getRefreshToken: state => state.refreshToken,
    getUser: state => {
      return {
        isConnected: state.isConnected,
        type: state.type,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken
      }
    }
  },
  mutations: {
    setUser: (state, user) => {
      state.isConnected = user.isConnected
      state.type = user.type
      state.accessToken = user.accessToken
      state.refreshToken = user.refreshToken
    },
    setHasPhoneNumber: (state, hasPhoneNumber) => {
      state.hasPhoneNumber = hasPhoneNumber
    }
  }
}

export default user
